import React, { useEffect, useState } from "react";
import { Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { AppButton, Panel } from "../ui";

const getCollectionName = (collection) =>
  collection?.name || collection?.collectionName || collection?.title || "Untitled Collection";

const getCollectionDescription = (collection) =>
  collection?.description || collection?.summary || "No Description";

const CollectionCollectionsSection = ({ collections }) => {
  const navigate = useNavigate();
  const [collectionsState, setCollectionsState] = useState(collections || []);

  useEffect(() => {
    setCollectionsState(collections || []);
  }, [collections]);

  return (
    <section className="collectionDetailSection">
      <Typography className="collectionDetailSectionTitle" variant="h5">
        Collections ({collectionsState.length})
      </Typography>

      <div className="collectionsList app-row-list">
        {collectionsState.map((collection) => (
          <Panel key={collection.id} className="collectionCard" hoverable>
            <div className="collectionCardContent">
              <div className="collectionCardInfo">
                <div className="collectionCardName">{getCollectionName(collection)}</div>
                <div className="collectionCardId">{collection?.id || "No ID"}</div>
                {collection?.status?.type && (
                  <div className="collectionCardStatus">{collection.status.type}</div>
                )}
              </div>

              <div className="collectionCardDesc">
                {getCollectionDescription(collection)}
              </div>

              <div className="collectionCardActions">
                <AppButton
                  className="collectionCardBtn"
                  kind="secondary"
                  onClick={() => navigate(`/collections/${collection.id}`)}
                >
                  Open
                </AppButton>
              </div>
            </div>
          </Panel>
        ))}
      </div>
    </section>
  );
};

export default CollectionCollectionsSection;
